import listing from "@/apollo/cruises/companies/listing.gql";
import by_id from "@/apollo/cruises/companies/by_id.gql";
import create_update from "@/apollo/cruises/companies/create_update.gql";
import details from "@/apollo/cruises/companies/details.gql";
import update_wallet from "@/apollo/cruises/companies/update_wallet.gql";

export const state = () => ({
  listing: [],
  loading: false,
  details: [],
  details_loading: false,
  creating: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:22PM
   * @param {*} state
   * @param {*} value
   */
  SET_LISTING(state, value) {
    state.listing = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:22PM
   * @param {*} state
   * @param {*} value
   */
  SET_LOADING(state, value) {
    state.loading = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:31PM
   * @param {*} state
   * @param {*} value
   */
  SET_DETAILS(state, value) {
    state.details = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:32PM
   * @param {*} state
   * @param {*} value
   */
  SET_DETAILS_LOADING(state, value) {
    state.details_loading = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:22PM
   * @param {*} state
   * @param {*} value
   */

  UPDATE_LISTING(state, value) {
    const _index = state.listing.findIndex((val) => val._id == value?.data?._id);
    if (_index == -1) state.listing.splice(0, 0, value?.data);
    else state.listing.splice(_index, 1, { ...state.listing[_index], ...value?.data });
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:23PM
   * @param {*} { commit }
   * @param {*} search_by
   * @returns {*}
   */
  fetchListing({ commit }, search_by) {
    commit("SET_LOADING", true);
    return new Promise(async (resolve) => {
      this.$apolloClient
        .query({ query: listing, variables: { search_by } })
        .then(({ data }) => {
          commit("SET_LISTING", data.cruiseCompanyListing);
          resolve(data.cruiseCompanyListing);
          commit("SET_LOADING", false);
        })
        .catch(() => commit("SET_LOADING", false));
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:26PM
   * @param {*} __
   * @param {*} _id
   * @returns {*}
   */
  by_id(__, _id) {
    return new Promise(async (resolve) => {
      this.$apolloClient.query({ query: by_id, variables: { _id } }).then(({ data }) => resolve(data.cruiseCompanyById));
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:27PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  fetchDetails({ commit }, payload) {
    commit("SET_DETAILS_LOADING", true);
    return new Promise(async (resolve) => {
      this.$apolloClient
        .query({ query: details, variables: { payload } })
        .then(({ data }) => {
          commit("SET_DETAILS_LOADING", false);
          commit("SET_DETAILS", data.cruiseCompanyDetails);
          resolve(data.cruiseCompanyDetails);
        })
        .catch((err) => {
          return err;
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:28PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  create_update({ commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$apolloClient
        .mutate({ mutation: create_update, variables: { payload } })
        .then(({ data }) => {
          commit("UPDATE_LISTING", data.cruiseCreateAndUpdate);
          resolve(data.cruiseCreateAndUpdate);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Feb 2025 | 12:29PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  update_wallet(__, payload) {
    return new Promise(async (resolve) => {
      this.$apolloClient.mutate({ mutation: update_wallet, variables: { payload } }).then(({ data }) => resolve(data.cruiseCompanyWalletUpdate));
    });
  }
};

export const getters = {
  listing: (state) => state.listing,
  loading: (state) => state.loading,
  creating: (state) => state.creating
};
